angular.module('wbDashboard').controller('PortfolioplusDeleteControllerAurea',
        ['$scope', '$q', '$uibModal', '$window', '$timeout', 'RiskScore', 'User', 'Milestone', 'PlanService', 'positionsResolve', 'DataService', 'Message',
function ($scope, $q, $uibModal, $window, $timeout, RiskScore, User, Milestone, PlanService, positionsResolve, DataService, Message) {


    $scope.portfolioChoices = [];
    $scope.portfolioMilestones = null;
    $scope.data = {
        ms: null
    };

    if (positionsResolve && !positionsResolve.milestones.length) {
        $scope.$state.go('.', {page: "delete", msId: null});
        $timeout(function() { $scope.deletePortfolioModal(); });
    } else if ($scope.$stateParams.page !== "confirm") {
        $scope.$state.go('.', {page: "confirm", msId: null}, {location: "replace"});
    }

    $scope.$watch(function() { return PlanService.user.getPortfolios(); }, function(portfolios) {
        if (portfolios) {
            $scope.portfolioChoices.length = 0;
            $scope.portfolioChoices.push(RiskScore.getCorePortfolio());
            angular.forEach(portfolios, function(p) {
                if (p.slug !== $scope.$stateParams.slug) {
                    $scope.portfolioChoices.push(p);
                }
            });
        }
    });

    $scope.$watch(function () { return PlanService.user.getPortfolioPositions($scope.$stateParams.slug); }, function (portfolioPositions) {
        if (portfolioPositions) {
            //this is already retrieved in parent, just need to trigger

            $scope.portfolioMilestones = {};
            angular.forEach(portfolioPositions.milestones, function(msPartial) {
                var ms = User.getMilestones(msPartial.milestone_id);
                if (ms) {
                    $scope.portfolioMilestones[ms.id] = angular.copy(ms);
                }
            });

            if (!portfolioPositions.milestones.length && $scope.$stateParams.page !== 'delete') {
                $scope.deletePortfolioModal();
            }
        }
    });

    $scope.getPortfolioName = PlanService.user.getPortfolioName;

    $scope.selectPortfolio = function(slug) {
        if (!$scope.$stateParams.msId) {
            $scope.goToPage('confirm');
            return;
        }

        $scope.data.ms.extra.portfolio_slug = slug;
        $timeout(function() {
            //want the portfolio_slug watcher to trigger before page change
            if (slug === "core") {
                $scope.goToPage('allocation-start');
            } else {
                $scope.goToPage('confirm');
            }
        },10);
    };
    $scope.allAssigned = function() {
        var all = true;
        angular.forEach($scope.portfolioMilestones, function(ms) {
            if (ms.allocation.allocation_slug === $scope.portfolio.slug) {
                all = false;
            }
        });
        return all;
    };
    $scope.goNextUnassigned = function() {
        var nextMsId = null;
        angular.forEach($scope.portfolioMilestones, function(ms) {
            if (ms.allocation.allocation_slug === $scope.portfolio.slug && !nextMsId) {
                nextMsId = ms.id;
            }
        });
        if (nextMsId) {
            $scope.goToPage({page: 'portfolio', msId: nextMsId });
        }
    };

    $scope.deletePortfolioModal = function() {
        if ($scope.$stateParams.page !== 'delete') {
            $scope.goToPage({page: "delete"});
        }

        var modalInstance = $uibModal.open({
            templateUrl: "modal-portfolioplus-delete-confirm.tpl.html",
            size: 'md',
            scope: $scope,
            windowClass: 'confirm-modal text-center'
        });

        modalInstance.result.then(function () {
            return $scope.deletePortfolio();
        }).catch(function () {
            if ($scope.portfolioPositions.milestones.length) {
                $window.history.back();
            } else {
                if (!$scope.pageData.errorMsg) {
                    $window.history.back();
                }
            }
        }).finally(function() {

        });
    };

    $scope.deletePortfolio = function() {
        $scope.pageData.sending = true;
        $scope.pageData.errorMsg = false;
        return $q.when(1).then(function() {
            var msRequests = [];
            if ($scope.portfolioMilestones) {
                angular.forEach($scope.portfolioMilestones, function (ms) {
                    var data = {
                        allocation_start: ms.allocation.allocation_start,
                        allocation_end: ms.allocation.allocation_end,
                    };
                    if (ms.type === 'build_wealth' || ms.type_account) {
                        data.allocation_end = ms.allocation.allocation_start;
                    }
                    var promise = PlanService.user.setMilestoneAllocation(ms.id, data);
                    msRequests.push(promise);
                });
            }
            return $q.all(msRequests);
        }).catch(function(response) {
            Message.set({
                text: "There was a problem updating Portfolios",
                type: "danger"
            });
            throw response;
        }).then(function() {
            return PlanService.user.removePortfolio($scope.portfolio.slug);
        }).catch(function(response) {
            Message.set({
                text: "Couldn't delete " + $scope.portfolio.name + " Portfolio.",
                type: "danger"
            });
            $scope.pageData.errorMsg = true;
            throw response;
        }).then(function() {
            return $q.all([
                PlanService.user.retrievePortfolios(null, true),
                //need to remove all data since positions could have changed
                User.retrieveAllMilestones(true, true)
            ]);
        }).then(function() {
            Message.set({
                text: "Successfully deleted " + $scope.portfolio.name + " Portfolio",
                type: "success"
            });
            $scope.$state.go('base.plans.custom.portfolioplus');
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };


    $scope.goNextPage = function() {
        var page = null;
        switch ($scope.$stateParams.page) {
            // case 'confirm':
            //     page = 'portfolio';
            //     break;
            // case 'portfolio':
            //     page = 'allocation-start';
            //     break;
            case 'allocation-start':
                page = 'allocation-end';
                if ($scope.data.ms.type === 'build_wealth' || $scope.data.ms.type_account) {
                    page = 'confirm';
                }
                break;
            case 'allocation-end':
                page = 'review-glide';
                Milestone.retrieveGlideFuture();

                break;
            case 'review-glide':
                page = 'confirm';
                break;
        }

        if (page) {
            $scope.goToPage(page);
        }
    };
    $scope.goToPage = function(params, options = {}) {
        if (typeof params === 'string') {
            params = {page: params};
        }
        if (params.page === 'confirm') {
            params.msId = null;
        }
        return $scope.$state.go('.', params, options);
    };

    $scope.viewPortfolioAllocation = function(allocation, cash) {
        var portfolio = angular.copy($scope.riskPortfolios[allocation.toFixed(1)]);

        portfolio = RiskScore.formatPortfolio(portfolio, cash, true);
        portfolio.total_value = 0;
        $scope.riskAllocation = portfolio;

        $scope.goToDetail();
    };

    $scope.goToDetail = function() {
        $scope.$state.go(".",{page:'allocation-detail'});
    };



    /*********************************
     ******* ALLOCATION PAGE *********
     *********************************/
    $scope.$watch('data.ms.extra.portfolio_slug', function(slug) {
        if (slug) {
            if (slug === 'core') {
                if ($scope.data.ms.allocation.recommendation) {
                    if (!$scope.data.ms.allocation.allocation_start || $scope.data.ms.allocation.allocation_start.length > 4) {
                        $scope.data.ms.extra.allocation_start_value = $scope.data.ms.allocation.recommendation.allocation_start*1;
                        $scope.data.ms.allocation.allocation_start = $scope.data.ms.allocation.recommendation.allocation_start;
                    }
                    if (!$scope.data.ms.allocation.allocation_end || $scope.data.ms.allocation.allocation_end.length > 4) {
                        $scope.data.ms.extra.allocation_end_value = $scope.data.ms.allocation.recommendation.allocation_end*1;
                        $scope.data.ms.allocation.allocation_end = $scope.data.ms.allocation.recommendation.allocation_end;
                    }
                }
            } else if (slug !== 'core') {
                $scope.data.ms.allocation.allocation_start = slug;
                $scope.data.ms.allocation.allocation_end = slug;
            }
        }
    });

    $scope.$watchGroup(['data.ms.extra.allocation_start_value','data.ms.extra.allocation_end_value'], function(data) {
        var [startValue, endValue] = data;

        if (startValue || startValue === 0) {
            $scope.data.ms.allocation.allocation_start = startValue.toFixed(1);
        }
        if (endValue || endValue === 0) {
            $scope.data.ms.allocation.allocation_end = endValue.toFixed(1);
        }
    });

    var transitionDeregisterHook = {};
    transitionDeregisterHook[0] = $scope.$transitions.onStart({ to: "base.plans.custom.portfolioplus.detail.delete.**" }, function(trans) {
        var ms;
        var msIdOld = trans.params('from').msId;
        var msIdNew = trans.params('to').msId;

        if (!msIdNew && msIdOld && $scope.data.ms && msIdOld === $scope.data.ms.id) {
            //going back to main page, update milestone with changes from milestone controller
            ms = $scope.portfolioMilestones[msIdOld];

            var slug = $scope.data.ms.extra.portfolio_slug;

            ms.allocation.allocation_start = $scope.data.ms.allocation.allocation_start;
            ms.allocation.allocation_end = $scope.data.ms.allocation.allocation_end;
            if (slug === "core") {
                ms.allocation.allocation_slug = null;
            } else {
                ms.allocation.allocation_slug = slug;
            }

            $scope.data.ms = null;
        }
        if (msIdNew && msIdOld !== msIdNew) {
            //going to edit milestone allocation pages
            //set up milestone controller with selected milestone
            ms = $scope.portfolioMilestones[msIdNew];

            Milestone.clearMS();
            Milestone.setMilestoneUpdateFromObject(ms);
            $scope.data.ms = Milestone.ms;
        }
    });
    transitionDeregisterHook[1] = $scope.$transitions.onSuccess({ to: $scope.$state.current.name+".**" }, function(trans) {
        $scope.pageData.page = trans.params('to').page;
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook[0]) {
            transitionDeregisterHook[0]();
        }
        if (transitionDeregisterHook[1]) {
            transitionDeregisterHook[1]();
        }
    });

}]);
